import { httpRetry } from '$core/helpers/http-retry';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { StaticStorage } from '../static-storage';
import { HeaderDataDto, MenuDataDto } from '../types';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getHeaderStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/header-data').pipe(
      httpRetry(5),
      tap((res: HeaderDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }

  public getHeaderMenuStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/menu-data').pipe(
      httpRetry(5),
      tap((res: MenuDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
